import { connect } from 'react-redux'
import CreateLesson from './create-lesson'
import { withMe } from 'pobble-components/dist/pobble-user'
import { withRouter } from 'react-router'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { createPresentation } from '../../../../stores/my-presentations/my-presentations.actions'
import { isCreatingPresentation } from '../../../../stores/my-presentations/my-presentations.selectors'

const mapStateToProps = (state, { me }) => ({
  pending: isCreatingPresentation(state).pending,
  canUseLessons: me.account.policy.can_use_lessons
})

const mapDispatchToProps = (dispatch, { me, history }) => {
  const createLessonReq = values =>
    dispatch(
      createPresentation({
        title: values.title,
        lesson_overview: values.lessonOverview
      })
    ).catch(errorHandler)
  return {
    onSubmit: values => {
      return createLessonReq(values).then(({ data }) => {
        data && history.push(`/lesson/${data.presentation.id}/`)
      })
    }
  }
}

export default withRouter(
  withMe(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CreateLesson)
  )
)
